"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RibbonItemBase = exports.RibbonItemType = void 0;
var RibbonItemType;
(function (RibbonItemType) {
    RibbonItemType[RibbonItemType["Button"] = 0] = "Button";
    RibbonItemType[RibbonItemType["SelectBox"] = 1] = "SelectBox";
    RibbonItemType[RibbonItemType["Menu"] = 2] = "Menu";
    RibbonItemType[RibbonItemType["NumberBox"] = 3] = "NumberBox";
    RibbonItemType[RibbonItemType["ColorBox"] = 4] = "ColorBox";
    RibbonItemType[RibbonItemType["SubMenu"] = 5] = "SubMenu";
})(RibbonItemType = exports.RibbonItemType || (exports.RibbonItemType = {}));
var RibbonItemBase = (function () {
    function RibbonItemBase(id, beginGroup) {
        if (beginGroup === void 0) { beginGroup = false; }
        this.beginGroup = false;
        this.id = id;
        this.beginGroup = beginGroup;
    }
    return RibbonItemBase;
}());
exports.RibbonItemBase = RibbonItemBase;
